import PropTypes, { string, number, bool } from 'prop-types'

export const propTypes = {
  messages: PropTypes.arrayOf(string),
  side: number,
  isPrecise: bool
}
